import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import 'components/index.js'
import 'assets/icons/index.js'
import VueCropper from 'vue-cropper'

Vue.use(VueCropper)

Vue.config.productionTip = false
Vue.use(ViewUI)

// window.addEventListener('popstate', function () { history.pushState(null, null, document.URL) });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
